import { uri } from "../uri";

export const head = (url: string, params = {}) => request("HEAD", url, params);

export const get = (url: string, params = {}) => request("GET", url, params);

export const del = (url: string, params = {}, data = {}) =>
  request("DELETE", url, params, data);

export const post = (url: string, data = {}, params = {}) =>
  request("POST", url, params, data);

export const put = (url: string, data = {}, params = {}) =>
  request("PUT", url, params, data);

export const patch = (url: string, data: Array<PatchObject>, params = {}) =>
  request("PATCH", url, params, data);

export interface PatchObject {
  value?: any;
  path: string;
  op: "replace" | "add" | "remove" | "copy" | "move" | "test";
  from?: string;
}

type Method = "HEAD" | "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

const toRequest = (method: Method, data: any): RequestInit => {
  if (method === "HEAD" || method === "GET") {
    return {
      method,
      headers: {
        "X-Timezone-Offset": new Date().getTimezoneOffset().toString()
      }
    };
  }

  return {
    method,
    headers: {
      "Content-Type":
        method === "PATCH" ? "application/json-patch+json" : "application/json",
      "X-Timezone-Offset": new Date().getTimezoneOffset().toString()
    },
    body: JSON.stringify(data)
  };
};

export const request = (method: Method, url: string, params = {}, data?: any) =>
  fetch(uri(url, params), toRequest(method, data)).then(resp => {
    if (resp.status === 401) {
      // if it is a 401 in the API, then the user has been logged out
      window.location.reload();
    }
    return resp;
  });

export const upload = (url: string, data: Blob, filename?: string) => {
  const body = new FormData();

  body.append("file", data, filename);

  const init: RequestInit = {
    method: "POST",
    body: body
  };

  return fetch(uri(url, {}), init);
};
